import { render, staticRenderFns } from "./renameDialog.vue?vue&type=template&id=21181d5c&scoped=true&"
import script from "./renameDialog.vue?vue&type=script&lang=js&"
export * from "./renameDialog.vue?vue&type=script&lang=js&"
import style0 from "./renameDialog.vue?vue&type=style&index=0&id=21181d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21181d5c",
  null
  
)

export default component.exports